import { MuiThemeProvider } from "@material-ui/core";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SnackbarProvider } from "notistack";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { useAuthContext } from "./auth/useAuthContext";
import { ThemeProvider } from "./providers/ThemeProvider";
import { listenTrips } from "./redux/slices/socketSlice";
import Router from "./routes";
import "./styles/main.scss";
import { THEME } from "./theme/theme";

function App() {
  const dispatch = useDispatch();
  const { user } = useAuthContext();

  useEffect(() => {
    const cleanup = async () => {
      if (user?.id) {
        await dispatch(listenTrips({ userId: user?.id }));
      }
    };

    // Call cleanup function inside the effect
    cleanup();

    return () => {
      cleanup();

      // No async here, just a synchronous function for cleanup
      console.log("Cleanup on component unmount or user change.");
    };
  }, [dispatch, user]);

  return (
    <MuiThemeProvider theme={THEME}>
      <BrowserRouter>
        <ThemeProvider>
          <HelmetProvider>
            {/* <PersistGate loading={null} persistor={persistor}> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <SnackbarProvider
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                autoHideDuration={3000}
              >
                <Router />
              </SnackbarProvider>
            </LocalizationProvider>
            {/* </PersistGate> */}
          </HelmetProvider>
        </ThemeProvider>
      </BrowserRouter>
    </MuiThemeProvider>
  );
}

export default App;
